<template>
	<div class="col-12 col-md-8">
		<h3>Change Password:</h3>
		<form v-on:submit.prevent="submitPasswordForm" data-vv-scope="changePassword">
			<div class="form-group row">
				<label class="col-sm-5 col-form-label">Password</label>
				<input
				type="password"
				v-model="password"
				placeholder="Password"
				name="password"
				ref="password"
				autocomplete="new-password"
				class="col-sm-7 form-control"
				>

				<label class="col-sm-5 col-form-label">Confirm Password</label>
				<input
				type="password"
				v-validate="'required|confirmed:password'"
				placeholder="Confirm Password"
				name="confirm_password"
				data-vv-as="Confirm Password"
				autocomplete="new-password"
				class="col-sm-7 form-control"
				>
			<div class="invalid-feedback">{{errors.first('changePassword.confirm_password')}}</div>
			</div>
			<div class="row justify-content-center">
				<ButtonWithLoading
				class="btn btn-primary"
				type="submit"
				text="Change Password"
				loadingText="Changing Password"
				successText="Password Changed"
				failureText="Error Changing Password"
				:state="passwordSubmitState"
				/>
			</div>
		</form>
	</div>
</template>

<script>

import ButtonWithLoading from "@/components/buttonWithLoading";
import { saveUserDetails } from "@/network/userRequests";

export default {
  name: "MyAccount",
  data: () => {
    return {

      passwordSubmitState: null,
      password: null,
    };
  },
  components: {
    ButtonWithLoading,
  },
  methods: {
    submitPasswordForm() {
      this.$validator.validateAll("changePassword").then(valid => {
        if (!valid) return;

        // console.log("clicked submit passwords");
        this.passwordSubmitState = "loading";
        const details = { password: this.password };
        saveUserDetails(
          { memberDetails: details },
          () => {
            //success saving password form
            this.passwordSubmitState = "success";
            this.errors.clear();
            this.$validator.reset();
          },
          () => {
            //failure saving password
            this.passwordSubmitState = "failure";
            this.message = "Error saving form";
          }
        );
      });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
